import React from 'react';
import {Link} from 'gatsby';

import {SupportedLanguage} from '../types';
import {Node} from '../gatsby/create-pages';

import '../styles/post-navs.css';

interface PostNavsProps {
	lang: SupportedLanguage;
	previous: Node;
	next: Node;
}

function Footer({lang, previous, next}: PostNavsProps) {
	const previousArrow = lang === 'en' ? '←' : '→';
	const nextArrow = lang === 'en' ? '→' : '←';

	return (
		<nav className="PostNavs">
			<ul className="Links">
				<li>
					{previous && (
						<Link to={previous.fields.slug} rel="prev">
							{previousArrow} {previous.frontmatter.title}
						</Link>
					)}
				</li>

				<li>
					{next && (
						<Link to={next.fields.slug} rel="next">
							{next.frontmatter.title} {nextArrow}
						</Link>
					)}
				</li>
			</ul>
		</nav>
	);
}

export default Footer;
